/* eslint-disable */
import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import withLocalization from '../../components/hoc/withLocalization';
import OfferHeader from '../../components/common/OfferHeader/OfferHeader';
import PinSearch from '../../components/PinOptimizedSearchPanel/PinSearch';
import { loadOfferDetails } from '../offerSearch/offerSearchSlice';
import { logAnalyticData } from '../../analytics';
import { useMediaQuery } from 'react-responsive';
import { setPinLnDetails } from '../OfferValidateContainer/PinOptFlowOfferSlice';
import { setUrlDetails } from '../OfferValidateContainer/PinOptFlowOfferSlice';
import { truncateString } from '../../util/CommonLogic';
import {
  SearchBackgroundDiv,
  PinSearchMainContainer,
  PinSearchInnerContainer,
  PinSearchFormContainer,
  PinSearchImgWrapper,
} from './PinSearchContainerStyled';
import NewOfferLoader from '../../components/common/NewOfferLoader/NewOfferLoader';
import isAsia from '../../util/isAsia';
import { getSiteIdentifier } from '../../util/SiteDetails';
import { OfferResponse } from '../offerSearch/types';

let logAnalyticCalled = false;
const PinOptOffer: FC<any> = (props: any): ReactElement => {
  const { localize, localizeImages } = props;
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const dispatch = useDispatch();
  const { path } = localizeImages('preview-sales-engine.static-content.images.intl-search-info-hero-image', 0, '4:3');
  const mobPath = localizeImages('preview-sales-engine.static-content.images.intl-search-info-hero-image', 0, '7:3');
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const isSubmitErr = useSelector((state: RootState) => state.offerDetails.hasError);
  const errorObj = useSelector((state: RootState) => state.offerDetails.error);
  const showCTA = useSelector((state: RootState) => state.offerDetails.showCTA);
  const callCenterPhone: any = useSelector((state: RootState) => state.offerDetails.nonFormatedCallcenterNo);
  const isPackageSold: any = useSelector((state: RootState) => state.offerDetails.isPackageSold);
  const errorCode: any = useSelector((state: RootState) => state.offerDetails.errorCode);
  const offerErrDetail: any = useSelector((state: RootState) => state.offerDetails);
  const offerDetails: OfferResponse = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  
  const defaultPhone = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');

  const errDetails = {
    errPhNo: callCenterPhone || '',
    isPkgSold: isPackageSold,
    errorCode: errorCode || '',
    callCenterCode: offerErrDetail?.callCenterCode,
    countryName: prospectDetails?.countryName,
  };
  const isLoading = useSelector((state: RootState) => state.offerDetails.loading);
  const { pinId } = useParams();
  //const pinId: any = props?.match?.params?.pinid || '';

  const getLastName: any = new URLSearchParams(window?.location?.search)?.get('ln') || '';
  const destination: any = new URLSearchParams(window?.location?.search)?.get('dest') || '';
  const brand: any = new URLSearchParams(window?.location?.search)?.get('brand') || '';
  //const effortCode: any = new URLSearchParams(window?.location?.search)?.get('efc') || '';

  const currentUrl = window.location?.href || '';
  const location = useLocation();
  const navigate = useNavigate();
  const siteIdentifier = getSiteIdentifier();

  //const phNo = localize('preview-sales-engine.static-content.copy.prospects.brandphonenumber');
  const imgPath: any = isMobile ? mobPath?.path : path;
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    let efcValue: any;

    // Case-insensitive search for 'efc'
    for (let [key, value] of searchParams.entries()) {
      if (key.toLowerCase() === 'efc') {
        efcValue = value;
        break;
      }
    }

    window.scrollTo(0, 0);
    const searchParam = location.search;
    const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
    if (!getUrlSearchParam) {
      sessionStorage.setItem('pinOptUrlSearchParam', searchParam);
      if (!prospectDetails && pinId && pinId?.length > 0 && getLastName && getLastName.length > 0) {
        const pinDetailsPayload: any = { pin: pinId.toUpperCase(), lastName: getLastName };
        dispatch(setPinLnDetails(pinDetailsPayload));
        dispatch(loadOfferDetails(pinId.toUpperCase(), getLastName, 'y', true));
      }
    }
  }, []);
  useEffect(() => {
    if (isSubmitErr || errorObj || showCTA) {
      navigate('/pin-error', { state: errDetails });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitErr, errorObj, showCTA]);

  //AM-8100
  // useEffect(() => {
  //   if (prospectDetails && prospectDetails?.firstName) {
  //     const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
  //     navigate('/validate' + getUrlSearchParam);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [prospectDetails]);

  useEffect(() => {
      if (offerDetails?.offers && offerDetails?.offers?.length > 0) {
        const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
        navigate('/offer-details' + getUrlSearchParam);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerDetails]);

  useEffect(() => {
    if (!logAnalyticCalled) {
      logAnalyticData(
        {
          event: 'pbePinPage',
          siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
          pageName: 'MVC ' + siteIdentifier + 'PBE PIN Page',
          pageHierarchy: '',
          server: 'MVC',
          website: 'MVC react',
          language: 'en',
        },
        {
          errorMessage: '',
          offerCode: 'Vacation Offer',
          // we do not know the offer at this point, so set to empty string
          offerType: '',
          flowldentifier: 'PIN',
          bookingStepName: 'MVC ' + siteIdentifier + '| PBE PIN Page',
        },
      );
      logAnalyticCalled = true;
    }
  }, []);
  useEffect(() => {
    const max_length = 255;
    const trunUrl = truncateString(currentUrl, max_length);
    dispatch(
      setUrlDetails({
        url: trunUrl,
        destination: destination,
        brand: brand,
      }),
    );
  });
  return (
    <>
      {isLoading && <NewOfferLoader />}
      <OfferHeader phone={defaultPhone} isThankyou={false} />
      <PinSearchMainContainer>
        <PinSearchInnerContainer>
          <PinSearchFormContainer>
            <PinSearch pinId={pinId} ln={getLastName}></PinSearch>
          </PinSearchFormContainer>
        </PinSearchInnerContainer>
        <PinSearchImgWrapper>
          <SearchBackgroundDiv $imageUrl={imgPath} />
        </PinSearchImgWrapper>
      </PinSearchMainContainer>
    </>
  );
};
export default withLocalization(PinOptOffer);
